import React, { useState } from "react";
import { ProgramTrainer } from "@/interfaces/ProgramTrainer";

const ProfileTrainerModal = ({ trainer, onClose }: { trainer: ProgramTrainer | null, onClose: () => void }) => {
  const [zoom, setZoom] = useState(false);

  if (!trainer) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50 p-2 sm:p-4">

      <div className="relative bg-white rounded-lg w-full max-w-4xl shadow-xl max-h-[95vh] ">

        <button
          onClick={onClose}
          className="absolute -top-3 -right-3 w-10 h-10 flex items-center justify-center bg-gray-300 rounded-full text-2xl font-bold text-gray-700 shadow hover:bg-gray-400 z-20"
        >
          ×
        </button>

        <div className="p-4 sm:p-6 flex flex-col sm:flex-row gap-4">

          <div className="flex justify-center sm:justify-start">
            <img
              src={trainer.sertificateSrc}
              alt={trainer.fullName}
              onClick={() => setZoom(true)}
              className="w-full max-w-[220px] sm:w-[300px] h-auto max-h-[400px] object-cover rounded-lg cursor-pointer hover:opacity-90 transition"
            />
          </div>

          <div className="flex flex-col p-1 sm:p-4 flex-1">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-800 text-center sm:text-left">
              {trainer.fullName}
            </h2>
            <p className="text-teal-600 font-bold mt-1 text-center mb-4 sm:text-left">
              {trainer.title}
            </p>

            <div className="max-h-[35vh] sm:max-h-[45vh] overflow-y-auto text-sm text-gray-700 mb-4">
              <h1 className="mb-2 font-semibold">Unit Kompetensi SKKNI :</h1>
              <ul className="list-disc pl-5 space-y-2">
                {trainer.description.map((d: string, i: number) => (
                  <li key={i}>{d}</li>
                ))}
              </ul>
            </div>
          </div>

        </div>
      </div>

      {zoom && (
        <div
          onClick={() => setZoom(false)}
          className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-[60] p-2"
        >
          <div
            className="relative max-w-full max-h-full"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setZoom(false)}
              className="absolute -top-5 -right-5 w-10 h-10 flex items-center justify-center bg-white rounded-full text-2xl font-bold text-gray-700 shadow hover:bg-gray-200 z-10"
            >
              &times;
            </button>

            <img
              src={trainer.sertificateSrc}
              alt="Certificate Preview"
              className="w-auto max-w-[95vw] max-h-[85vh] rounded-lg shadow-2xl object-contain"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileTrainerModal;
